import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'
import SroiReportPayloadEditForm from './SroiReportPayloadEditFormOld'

import useManageEditFormData from '../../../../hooks/formHooks/useManageEditFormData'

import {
  getSroiReportPayloadIsLoadingSelector,
  sroiReportPayloadSelector
} from '../../../../modules/selectors/socialReturnOnInvestment'
import { clearGetSroiReportPayload, getSroiReportPayload } from '../../../../modules/actions/socialReturnOnInvestment'

import { SROI_REPORT_PAYLOAD_EDIT } from '../../../../constants/forms'
import { HARDCODED_SROI_REPORT_ID } from '../index'

const SroiReportPayloadEdit = ({ fetchSroiReportHandler }) => {
  const dispatch = useDispatch()

  const sroiReportPayload = useSelector(sroiReportPayloadSelector)
  const getSroiReportPayloadIsLoading = useSelector(getSroiReportPayloadIsLoadingSelector)

  const isFormLoading = useMemo(() => {
    return getSroiReportPayloadIsLoading || !sroiReportPayload
  }, [getSroiReportPayloadIsLoading, sroiReportPayload])

  const getSroiReportPayloadHandler = useCallback(() => {
    dispatch(getSroiReportPayload({ id: HARDCODED_SROI_REPORT_ID }))
  }, [dispatch])

  const clearSroiReportPayloadHandler = useCallback(() => {
    dispatch(clearGetSroiReportPayload())
  }, [dispatch])

  useManageEditFormData({
    formName: SROI_REPORT_PAYLOAD_EDIT,
    loadedDataId: sroiReportPayload.id,
    getDataHandler: getSroiReportPayloadHandler,
    clearDataHandler: clearSroiReportPayloadHandler
  })

  return (
    <FormDrawerWrapper
      formName={SROI_REPORT_PAYLOAD_EDIT}
      SkeletonFormComponent={SkeletonSingleSectionForm}
      title="SROI Input Values"
      isFormLoading={isFormLoading}
      showOpenButton={false}
    >
      <SroiReportPayloadEditForm fetchSroiReportHandler={fetchSroiReportHandler} />
    </FormDrawerWrapper>
  )
}

SroiReportPayloadEdit.propTypes = {
  fetchSroiReportHandler: PropTypes.func.isRequired
}

export default SroiReportPayloadEdit
